// Columnas para exportación a Excel de Tipos de Documento.
export const columnsExcel = [
  { key: 'nombre', header: 'Nombre' },
  { key: 'descripcion', header: 'Descripción' },
  { key: 'requiereVencimiento', header: 'Requiere vencimiento' },
  { key: 'estado', header: 'Estado' },
  { key: 'updatedAt', header: 'Última actualización' },
];
